module.exports = __webpack_public_path__ + "img/nav-hover.3395addf.png";